import styled from '@emotion/styled'

export const ExportsCards = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, 298px);
  justify-content: center;
  grid-column-gap: 24px;
  grid-row-gap: 24px;
`
